import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    {
      path: 'game',
      loadChildren: () =>
      import('./modules/game/game.module').then((m) => m.GameModule),
    },
    {
      path: 'admin',
      loadChildren: () =>
      import('./modules/admin/admin.module').then((m) => m.AdminModule),
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
